import { render, staticRenderFns } from "./m-chart-donut.vue?vue&type=template&id=74a7cae0&scoped=true&"
import script from "./m-chart-donut.vue?vue&type=script&lang=js&"
export * from "./m-chart-donut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a7cae0",
  null
  
)

export default component.exports